import { render } from "./WristbandMaintenanceCreateForm.vue?vue&type=template&id=108f3f26&scoped=true"
import script from "./WristbandMaintenanceCreateForm.vue?vue&type=script&lang=js"
export * from "./WristbandMaintenanceCreateForm.vue?vue&type=script&lang=js"

import "./WristbandMaintenanceCreateForm.vue?vue&type=style&index=0&id=108f3f26&scoped=true&lang=css"
import "./WristbandMaintenanceCreateForm.vue?vue&type=style&index=1&id=108f3f26&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-108f3f26"]])

export default __exports__